import { DateTime } from 'luxon';

import type { IDateRange } from '../lib/interfaces';
import { formatRequestDate } from '../lib/utils';

export const COMPANY_EVENTS_PAGE_SIZE = 1000;

export function defaultCompanyEventsDateRange(): IDateRange {
  return {
    date_from: formatRequestDate(DateTime.now().minus({ months: 1 }).toJSDate()),
    date_to: formatRequestDate(DateTime.now().plus({ months: 3 }).toJSDate()),
  };
}
